const EXTERNAL_LINK_PROPS: { target: string; rel: string } = {
  target: "_blank",
  rel: "noreferrer noopener",
};

export default EXTERNAL_LINK_PROPS;
